import { render, staticRenderFns } from "./color_group_all.vue?vue&type=template&id=f4066ec0&scoped=true"
import script from "./color_group_all.vue?vue&type=script&lang=ts"
export * from "./color_group_all.vue?vue&type=script&lang=ts"
import style0 from "./color_group_all.vue?vue&type=style&index=0&id=f4066ec0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4066ec0",
  null
  
)

export default component.exports